// import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
// import ButtonLoadingSpinner from "../ButtonLoadingSpinner";
// import { toast } from "react-toastify";
// import FormDataJson from "form-data-json-convert";
// import { useMoyasarSaveTokenMutation } from "../../store/services/smApi";
import LoadingSpinner from "../LoadingSpinner";
import i18next from "../../i18n";
import { useFetchMoyaSarCredentialsMutation } from "../../store/services/smApi";
import { notifier } from "../../utils/notifier";
import { useSelector } from "react-redux";
function MoyasarPayment ({
  currency,
  amount,
  handlePayment,
  loadingInit,
  isUpdateMethod = false,
  subscriptionId
}) {
  const merchant_id = useSelector((state) => state?.configStore?.merchant?.id);
  //   const { t } = useTranslation();
  //   const [moyasarSaveToken] = useMoyasarSaveTokenMutation();
  //   const [moyasarPaymentData, setMoyasarPaymentData] = useState({});
  const moyaSarForm = useRef(null);
  const [moysarData, setMoysarData] = useState(null);
  const [fetchMoyaSarCredentials, { isLoading: isFetchingMoyaSarCredentials }] = useFetchMoyaSarCredentialsMutation();

  // Fetch Moyasar credentials once
  const getMoyasarCredentials = async () => {
    try {
      const result = await fetchMoyaSarCredentials();
      if (result.data) {
        setMoysarData(result.data);
      } else if (result.error) {
        console.error("Failed to fetch Moyasar credentials:", result.error);
        notifier.error("Failed to load payment credentials. Please try again later");
      }
    } catch (error) {
      console.error("Error fetching Moyasar credentials:", error);
      notifier.error("Failed to load payment credentials. Please try again later");
    }
  };

  // Initialize Moyasar with backend data
  const initMoyasar = (handleData) => {
    console.log("initMoyasar?=>", handleData);
    if (+amount < 1 || !moyaSarForm.current || !moysarData) {
      console.log("WILL RETURN");
      return;
    }

    const on_completed = async (data) => {
      await handlePayment("moyasar", null, null, true, data);
    };

    const on_failure = async (error) => {
      console.error("Moyasar payment failed:", error);

      // Check if the error is due to network issues (Failed to fetch)
      const errorMessage = error?.message?.toLowerCase() || "";
      const isNetworkError = errorMessage.includes("failed to fetch") ||
                            errorMessage.includes("network") ||
                            errorMessage.includes("connection");

      if (isNetworkError) {
        notifier.error("Network error occurred. Please check your connection and try again");
      } else if (error?.type === "card_error") {
        notifier.error("Card payment failed. Please check your card details and try again");
      } else if (error?.type === "authentication_error") {
        notifier.error("Payment authentication failed. Please try again");
      } else {
        notifier.error("Payment failed. Please try again later");
      }
      return Promise.resolve();
    };

    window.Moyasar.init({
      element: moyaSarForm.current,
      amount: (amount || handleData.amount) * 100, // in halalas
      language: i18next.language,
      currency: currency || "SAR",
      description: handleData.subscription_id ? "Subscription Payment" : "Payment",
      publishable_api_key: moysarData.public_key,
      callback_url: handleData.callback_url || (
        isUpdateMethod
          ? window.location.origin + "/checkout/update-payment-method-process"
          : window.location.origin + "/checkout/processing"
      ),
      on_completed,
      on_failure,
      methods: ["creditcard"],
      credit_card: {
        save_card: true,
        manual: handleData.manual || isUpdateMethod // (authorize only) when updating payment method
      },
      metadata: {
        merchant_id,
        reference: handleData.reference,
        subscription_id: handleData.subscription_id || subscriptionId,
        operation_for: handleData.operation_for || (isUpdateMethod ? "authorization" : "payment")
      }
    });
  };

  // Fetch credentials + handleData once
  useEffect(() => {
    const setup = async () => {
      if (!handlePayment) return;
      await getMoyasarCredentials();
    };
    setup();
  }, []);

  // // When credentials + amount ready → fetch handleData and init
  // // const hasInitialized = useRef(false);
  // useEffect(() => {
  //   let isMounted = true;
  //   let retryCount = 0;
  //   const maxRetries = 50;
  //   const setupPayment = async () => {
  //     if (!isMounted) return;
  //     if (moysarData && amount && moyaSarForm.current) {
  //       // Check if Moyasar is available, if not wait for it
  //       if (!window.Moyasar) {
  //         if (retryCount < maxRetries) {
  //           retryCount++;
  //           setTimeout(() => initMoyasar(), 100);
  //         } else {
  //           console.error("Moyasar SDK failed to load.");
  //           notifier.error("Payment system failed to load. Please refresh the page and try again");
  //         }
  //       }
  //     }
  //   };
  //   setupPayment();
  //   return () => { isMounted = false; };
  // }, [moysarData, amount, currency]);

  useEffect(() => {
    // setMoyasarPaymentData({});
    initMoyasar({});
  }, [amount, currency, loadingInit, moyaSarForm.current, moysarData]);

  // Add network connectivity listener
  useEffect(() => {
    const handleOffline = () => {
      console.warn("Network connection lost");
      notifier.warning("Network connection lost. Please check your internet connection");
    };

    const handleOnline = () => {
      console.log("Network connection restored");
      notifier.success("Network connection restored");
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return (
    <div className="w-100">
      <div id="root-form" className="w-100">
        {isFetchingMoyaSarCredentials
          ? (
            <LoadingSpinner />
            )
          : (
            <form ref={moyaSarForm} key={`${currency}-${amount}`} id="moyasar-payment-form" className="w-100"></form>
            )}
      </div>
    </div>
  );
}

export default MoyasarPayment;
